import feathersClient, { makeServicePlugin, BaseModel } from '@/api-client'

class SubmitOrder extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'SubmitOrder'
}

const servicePath = 'submit-orders'
const servicePlugin = makeServicePlugin({
  Model: SubmitOrder,
  // IMPORTANT
  whitelist: ['$eager', '$iRegexp', '$regex', '$options'],
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
